<div class="accordian-wrapper">
  @if (sections && sections.length > 0) {
    <mat-accordion class="connected-section-list" cdkDropList (cdkDropListDropped)="onSectionReorder($event)">
      @for (section of sections; track section.get('referenceId').value; let i = $index; let first = $first; let last = $last) {
        <mat-expansion-panel
          id="section-{{ i }}"
          class="section-item"
          [cdkDragDisabled]="isExpanded(i)"
          cdkDrag
          [expanded]="isExpanded(i)"
          (afterExpand)="scrollToSection(i)"
          [ngClass]="{
            'first-section': first,
            'last-section': last,
            'middle-section': !first && !last,
          }"
        >
          <mat-expansion-panel-header [ngClass]="{ invalid: section.invalid }">
            <mat-panel-title>
              <mat-icon class="section-icon material-icons-outlined material-symbols-outlined"
                >{{ getSectionIcon(getSectionType(section)) }}
              </mat-icon>
              {{ getSectionLabel(getSectionType(section)) }}
              @if (section.invalid) {
                <mat-icon
                  class="required-icon"
                  fontIcon="error_outlined"
                  matTooltip="Information required"
                  matTooltipShowDelay="500"
                ></mat-icon>
              }
              <mat-panel-description>
                {{ getSectionSubtitle(section) }}
              </mat-panel-description>
            </mat-panel-title>
            <div class="section-controls" (click)="$event.stopPropagation()">
              <button type="button" class="control-btn remove-btn" (click)="onRemoveSection(i)" title="Remove section">
                <mat-icon>close</mat-icon>
              </button>
              <mat-icon
                class="drag-indicator"
                [class.disabled]="isExpanded(i)"
                cdkDragHandle
                [cdkDragHandleDisabled]="isExpanded(i)"
                [attr.title]="isExpanded(i) ? 'Cannot drag when expanded' : 'Drag to reorder'"
                >drag_indicator
              </mat-icon>
            </div>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <div class="panel-body" [formGroup]="section">
              <div class="panel-container">
                <ul class="section-name-description-section">
                  <li class="section-name-description-row">
                    <section class="basic-flex-container">
                      <div class="section-field-container">
                        <h3 class="basic-flex-container">
                          <mat-icon fontSet="material-icons-outlined">drive_file_rename_outline</mat-icon>
                          Section name *
                        </h3>
                        <div>
                          <input type="text" formControlName="displayName" placeholder="e.g. Candidate Resume/" required />
                        </div>
                      </div>
                      <div class="section-field-container">
                        <h3 class="basic-flex-container">
                          <mat-icon fontSet="material-icons-outlined">description</mat-icon>
                          Section description
                        </h3>
                        <div>
                          <input type="text" formControlName="description" placeholder="e.g. Pick a Resume/CV file from a record" />
                        </div>
                      </div>
                    </section>
                  </li>
                </ul>
                @switch (section.get('type').value) {
                  @case (SectionType.File) {
                    <app-file-section
                      [fileSection]="section"
                      [entityType]="getEntityType()"
                      [namespace]="getNamespace()"
                      [combinedOutput]="combinedOutput">
                    </app-file-section>
                  }
                  @case (SectionType.FixedFile) {
                    <app-fixed-file-section
                      [workflowConfigId]="workflowConfigId"
                      [section]="section"
                      [entityType]="getEntityType()"
                      [namespace]="getNamespace()"
                      [combinedOutput]="combinedOutput">
                    </app-fixed-file-section>
                  }
                  @case (SectionType.DocMergeTemplateSection) {
                    <app-docmerge-template-section
                      [section]="section"
                      [entityType]="getEntityType()">
                    </app-docmerge-template-section>
                  }
                  @case (SectionType.Certification) {
                    <app-certification-section
                      [section]="section"
                      [entityType]="getEntityType()"
                      [namespace]="getNamespace()"
                      [allCertifications]="allCertifications"
                      [allCertificationGroups]="allCertificationGroups"
                      [combinedOutput]="combinedOutput">
                    </app-certification-section>
                  }
                  @default {
                    Invalid section type
                  }
                }
              </div>
            </div>
          </ng-template>
        </mat-expansion-panel>
      }
    </mat-accordion>
  }
</div>
